import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ncis-strapi',
  templateUrl: './strapi.component.html',
  styleUrls: ['./strapi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrapiComponent {
  @Input()
  public content: string = '';

  @Input()
  public noPadding = false;
}
